import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

import { AgentPerformanceData } from '../models/agent-performance';

@Injectable({
  providedIn: 'root',
})
export class AgentPerformanceService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/agent`;

  getAgentPerformanceData(agentId: string) {
    const url = `${this.baseUrl}/agent-performance?agentId=${agentId}`;
    return firstValueFrom(this.http.get<AgentPerformanceData>(url));
  }
}
